import { render } from "./dictionary.vue?vue&type=template&id=1ff35db6&scoped=true"
import script from "./dictionary.vue?vue&type=script&lang=js"
export * from "./dictionary.vue?vue&type=script&lang=js"

import "./dictionary.vue?vue&type=style&index=0&id=1ff35db6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ff35db6"

export default script